export default "__VITE_ASSET__f699860f__"